/** Jump to the top of the page when opening or leaving an exercise. */
export function scrollToTop() {
  if (typeof window === "undefined") return
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  window.scrollTo({ top: 0, left: 0, behavior: reduce ? "auto" : "smooth" })
}

/** Bring a submitted score panel into view after grading. */
export function scrollResultIntoView(selector = ".ui-reveal") {
  if (typeof window === "undefined") return
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  window.requestAnimationFrame(() => {
    document.querySelector(selector)?.scrollIntoView({
      behavior: reduce ? "auto" : "smooth",
      block: "nearest",
    })
  })
}
